export type FileSortKey = 'position' | 'name' | 'created_at';

export type FileSort = { key: FileSortKey; dir: 1 | -1 };

export type FileSortLabels = Partial<Record<FileSortKey, string>>;

type SortableFile = { name?: string; created_at?: string; position?: number | null };

export const compareFilesBy =
    (sort: FileSort) =>
    (a: SortableFile, b: SortableFile): number => {
        if (sort.key === 'position') {
            // Unset positions (freshly added files) sort to the end.
            const pa = a.position ?? Number.MAX_SAFE_INTEGER;
            const pb = b.position ?? Number.MAX_SAFE_INTEGER;

            return sort.dir * (pa - pb);
        }

        if (sort.key === 'name') {
            // Czech collation, accent-aware and case-insensitive, natural numbers
            // (Foto (2) before Foto (10)) — parity with the backend CzechCollator.
            return (
                sort.dir *
                String(a.name ?? '').localeCompare(String(b.name ?? ''), 'cs', {
                    numeric: true,
                    sensitivity: 'accent',
                })
            );
        }

        return sort.dir * String(a.created_at ?? '').localeCompare(String(b.created_at ?? ''));
    };

export const sortFilesBy = <T extends SortableFile>(files: T[], sort: FileSort): T[] =>
    [...files].sort(compareFilesBy(sort));
